import { AxiosResponse } from 'axios';

import axiosClient from '@/plugins/axios.client';
import $emitter from '@/plugins/mitt.event';

import { ReportInput } from '@/models/report.model';
import { Message, MessageType, MessageEvent } from '@/types/emitter.type';

class ReportService {
  getAllReports() {
    // const today = new Date();
    // const earliestDate = subYears(today, 3);
    // const earliest = startOfYear(earliestDate).toISOString();

    return axiosClient
      .post(`collections/get/bericht`, {
        populate: 1,
        // filter: {
        //   zeitstempel: {
        //     $gt: earliest
        //   }
        // }
        sort: {
          zeitstempel: -1
        }
      })
      .then((resp: AxiosResponse) => resp.data.entries);
  }

  saveReport(report: ReportInput | ReportInput[]) {
    return axiosClient
      .post(`collections/save/bericht`, {
        data: report
      })
      .then((resp: AxiosResponse) => {
        const msg: Message = {
          type: MessageType.Default,
          text: ''
        };

        if (resp.status === 200) {
          msg.text = 'Bericht erfolgreich angelegt.';
          msg.type = MessageType.Success;
        } else {
          msg.text = 'Bericht konnte nicht angelegt werden';
          msg.type = MessageType.Error;
        }

        $emitter?.emit(MessageEvent.Global, msg);
        return resp.data;
      })
      .catch(() => {
        const msg: Message = {
          type: MessageType.Error,
          text: 'Bericht konnte nicht angelegt werden'
        };
        $emitter?.emit(MessageEvent.Global, msg);
      });
  }

  deleteReport(id: string) {
    return axiosClient
      .post('collections/remove/bericht', {
        filter: {
          _id: id
        }
      })
      .then((resp: AxiosResponse) => {
        const msg: Message = {
          type: MessageType.Default,
          text: ''
        };

        if (resp.status === 200) {
          msg.text = 'Bericht erfolgreich entfernt.';
          msg.type = MessageType.Success;
        } else {
          msg.text = 'Bericht konnte nicht entfernt werden';
          msg.type = MessageType.Error;
        }

        $emitter?.emit(MessageEvent.Global, msg);
        return resp.data;
      })
      .catch(() => {
        const msg: Message = {
          type: MessageType.Error,
          text: 'Bericht konnte nicht entfernt werden'
        };
        $emitter?.emit(MessageEvent.Global, msg);
      });
  }

  removeReports(ids: string[]) {
    return axiosClient
      .post(`collections/remove/bericht`, {
        filter: {
          _id: {
            $in: ids
          }
        }
      })
      .then((resp: AxiosResponse) => resp.data);
  }
}

export default new ReportService();
